module.exports = __webpack_public_path__ + "static/tech-icon-button-0f8393b6410f9e887b86124d870f9b81.png";